import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "./Header";
import API from "../api";

export default function ResetPassword() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    // Sécurité + calcul force password
    const sanitize = (str) => str.replace(/[<>]/g, "").trim();

    const strengthChecks = [
    password.length >= 8,
    /[A-Z]/.test(password),
    /\d/.test(password),
    /[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]/.test(password),
];

    const strength = strengthChecks.filter(Boolean).length;
    const barColors = [
    "bg-red-600",
    "bg-orange-500",
    "bg-yellow-500",
    "bg-green-500",
    ];
    const strengthColor = strength > 0 ? barColors[strength - 1] : "bg-red-600";

    const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const cleanPassword = sanitize(password);

    if (cleanPassword !== confirmPassword) {
        return setMessage("Passwords do not match");
    }

    // Validation stricte
    if (strength < 4) {
        return setMessage(
        "Password must contain at least 8 characters, 1 uppercase letter, 1 number and 1 special symbol"
        );
    }

    try {
        const response = await API.post(`/reset-password/${token}`, {
        password: cleanPassword,
        });
        setMessage(response.data.message);
    } catch (error) {
        console.log(error);
        setMessage("Your reset link has expired or is invalid");
    }
    };

    return (
    <div className="relative min-h-screen bg-[#0D1117] flex items-center justify-center px-4 sm:px-6 lg:px-8">

        <Header />

        <div className="absolute bottom-0 right-0 overflow-hidden lg:inset-y-0 pointer-events-none">
        <div className="w-auto h-full bg-gradient-to-tr from-[#1F6FEB]/20 to-[#3B82F6]/10 rounded-full transform rotate-45 scale-150" />
        </div>

        <div className="relative z-10 w-full max-w-md bg-[#161B22] rounded-2xl shadow-[0_0_20px_#3B82F6]/20 p-8 mt-20">

        <h2 className="text-3xl font-bold text-center text-[#E6EDF3] mb-2 font-pj">
            Reset Password 🔒
        </h2>
        <p className="text-center text-[#8B949E] mb-8">
            Enter your new password to secure your account
        </p>

        <form onSubmit={handleSubmit} className="space-y-5">

            <div>
            <label className="block text-[#8B949E] mb-1 font-medium">
                New Password
            </label>
            <input
                type="password"
                value={password}
                minLength={8}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-[#30363D] rounded-xl focus:ring-2 focus:ring-[#1F6FEB] focus:outline-none bg-[#0D1117] text-[#E6EDF3] placeholder-[#6E7681]"
                placeholder="••••••••"
                required
            />
            {/* Barre de force */}
            <div className="w-full h-2 rounded-md bg-[#30363D] mt-2">
                <div
                className={`h-full rounded-md transition-all duration-300 ${strengthColor}`}
                style={{ width: `${(strength / 4) * 100}%` }}
                ></div>
            </div>
            </div>

            <div>
            <label className="block text-[#8B949E] mb-1 font-medium">
                Confirm Password
            </label>
            <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full px-4 py-3 border border-[#30363D] rounded-xl focus:ring-2 focus:ring-[#1F6FEB] focus:outline-none bg-[#0D1117] text-[#E6EDF3] placeholder-[#6E7681]"
                placeholder="••••••••"
                required
            />
            </div>

            <button
            type="submit"
            className="w-full py-3 mt-4 text-white bg-[#1F6FEB] hover:bg-[#388BFD] rounded-xl font-semibold transition shadow-[0_0_10px_#1F6FEB]/30"
            >
            Reset Password
            </button>
        </form>

        {message && (
            <p
            className={`text-sm mt-4 text-center font-medium ${
                message.toLowerCase().includes("success")
                ? "text-green-400"
                : "text-red-500"
            }`}
            >
            {message}
            </p>
        )}
        </div>
    </div>
    );
}
